import { useState } from 'react';
import { backupApi } from '../../api/backup';
import { useToast } from '../../components/Toast';

export default function DataBackup() {
  const toast = useToast();
  const [exporting, setExporting] = useState(false);
  const [preview, setPreview] = useState<string | null>(null);

  const handleExport = async () => {
    setExporting(true);
    try {
      const json = await backupApi.export();
      setPreview(json);
      // Also trigger download
      const blob = new Blob([json], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `a5core_backup_${new Date().toISOString().substring(0, 10)}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.addToast('Backup exported successfully', 'success');
    } catch (err) {
      toast.addToast(`Export failed: ${err instanceof Error ? err.message : 'Unknown error'}`, 'error');
    }
    setExporting(false);
  };

  return (
    <div className="space-y-6 max-w-4xl">
      <h1 className="text-xl font-bold text-gray-900">Data Backup</h1>

      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h2 className="font-semibold text-gray-900 mb-2">Export Backup</h2>
        <p className="text-sm text-gray-600 mb-4">
          Export all company data as a JSON file. This includes accounts, persons, journal entries,
          invoices, tax rates, document serials, and all related records.
        </p>
        <button
          className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 disabled:opacity-50"
          onClick={handleExport}
          disabled={exporting}
        >
          {exporting ? 'Exporting...' : 'Export Full Backup'}
        </button>
      </div>

      {preview && (
        <div className="bg-white rounded-lg border border-gray-200 p-4">
          <h2 className="font-semibold text-gray-900 mb-2">Preview</h2>
          <pre className="text-xs bg-gray-50 p-3 rounded-md overflow-auto max-h-96">
            {preview.substring(0, 2000)}{preview.length > 2000 ? '\n... (truncated)' : ''}
          </pre>
        </div>
      )}

      <div className="bg-yellow-50 rounded-lg border border-yellow-200 p-4">
        <h3 className="font-semibold text-yellow-800 mb-1">Important Notes</h3>
        <ul className="text-sm text-yellow-700 space-y-1 list-disc list-inside">
          <li>The backup file contains all financial data for the current workspace.</li>
          <li>Store the backup file securely -- it contains sensitive financial information.</li>
          <li>Import functionality will be available in a future release.</li>
        </ul>
      </div>
    </div>
  );
}
